// src/components/motion/CountUp.tsx
// 数字のカウントアップ（スコア等）。reduced-motion時は最終値を即表示。
import React from 'react';
import {
    animate,
    useReducedMotion,
} from 'framer-motion';

interface Props {
    to: number;
    from?: number;
    duration?: number;
    decimals?: number;
    suffix?: string;
    className?: string;
}

const CountUp: React.FC<Props> = ({
    to,
    from = 0,
    duration = 1.1,
    decimals = 0,
    suffix = '',
    className,
}) => {
    const reduce = useReducedMotion();
    const ref = React.useRef<HTMLSpanElement>(null);

    React.useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const format = (v: number) => v.toFixed(decimals) + suffix;
        if (reduce) {
            el.textContent = format(to);
            return;
        }
        const controls = animate(from, to, {
            duration,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => {
                el.textContent = format(v);
            },
        });
        return () => controls.stop();
    }, [to, from, duration, decimals, suffix, reduce]);

    return (
        <span ref={ref} className={className} style={{ fontFeatureSettings: '"tnum" 1' }}>
            {from.toFixed(decimals) + suffix}
        </span>
    );
};

export default CountUp;
